import { render, staticRenderFns } from "./GlobalSearchPopup.vue?vue&type=template&id=9c0b851e&scoped=true&"
import script from "./GlobalSearchPopup.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchPopup.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearchPopup.vue?vue&type=style&index=0&id=9c0b851e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0b851e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButton: require('/app/components/UI/UiButton.vue').default})
